/* eslint-disable */
export default {
  topic: 'Titre de la réunion',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
